export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  env: 'ssr',
  url: 'https://ssr.glovostore.com',
  api: {
    url: '/ecommerce/',
  },
  replacementsUrl: 'https://replacements-staging.glovostore.com',
  aws: {
    staticUrl: 'https://glovostore-pre.s3.amazonaws.com/glovostore/static/'
  },
  processout: {
    production: false,
    id: 'test-proj_BeUWoNq2wjESPsmhbSnxOSL35wvM4TMP',
  },
  gPay: {
    environment: 'TEST',
    merchantId: 'Glovostore',
    merchantName: 'Glovostore',
  },
  gMaps: {
    key: 'AIzaSyB4F8lOLmVV7N_elMq_FHNQKtabOfquu90',
  },
  hotjar: {
    id: 4966564,
  },
  packHelp: {
    urlDesign: 'https://glovo.demo.whitelabel.np.packhelp.com',
  },
  doofinderStoreId: '8f09e79e-8c17-4267-b672-c8e7bc470c06',
  posthog: {
    apiKey: 'phc_EHHJCiUi2imvhB9pSL0Yg2xkgtlP0GB0Pz0AA53O0QZ',
    apiHost: 'https://eu.i.posthog.com',
    enabled: true,
    projectId: 134917
  },
  sentry: {
    dsn: '',
    enabled: false,
    tracesSampleRate: 0,
    organization: '',
    projectId: 0,
  },
};
